/* Polyvora homepage: scale dial, live line, 120 V filter and goal cards.
   Everything is read from the page markup, so editing blocks in the theme editor changes what this shows. */
(function () {
  if (window.__pvHome) return;
  window.__pvHome = true;

  var GLYPH = [44, 56, 72, 88];
  var state = { tier: null };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }
  function reduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* goal buttons: reflect the chosen tier */
  function syncGoals() {
    document.querySelectorAll('.pv-goal').forEach(function (g) {
      g.setAttribute('aria-pressed', state.tier !== null && +g.getAttribute('data-pv-tier') === state.tier ? 'true' : 'false');
    });
  }
  function wireGoals() {
    document.querySelectorAll('.pv-goal:not([data-pv-ready])').forEach(function (g) {
      g.setAttribute('data-pv-ready', '1');
      g.addEventListener('click', function () {
        var input = document.getElementById('pv-scale');
        if (input) {
          input.value = g.getAttribute('data-pv-tier');
          input.dispatchEvent(new Event('input', { bubbles: true }));
          var d = document.getElementById('pv-dial');
          if (d) d.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' });
        }
      });
    });
    syncGoals();
  }

  function initRange(root) {
    root.setAttribute('data-pv-ready', '1');
    var input = root.querySelector('#pv-scale');
    var ticks = root.querySelector('[data-pv="ticks"]');
    var line = root.querySelector('[data-pv="line"]');
    var grid = root.querySelector('[data-pv="grid"]');
    var outFor = root.querySelector('[data-pv="for"]');
    var outSt = root.querySelector('[data-pv="stations"]');
    var outPr = root.querySelector('[data-pv="price"]');
    var chip = root.querySelector('[data-pv="f120"]');
    var offText = root.getAttribute('data-off') || 'Not offered at this size';
    var fmt;
    try {
      fmt = new Intl.NumberFormat(root.getAttribute('data-locale') || undefined, {
        style: 'currency', currency: root.getAttribute('data-currency') || 'USD', maximumFractionDigits: 0
      });
    } catch (e) {
      fmt = { format: function (n) { return '$' + Math.round(n).toLocaleString('en-US'); } };
    }
    function money(cents) { return fmt.format(cents / 100); }

    var heads = grid.querySelectorAll('.pv-colhead[data-t]');
    var tiers = Array.prototype.map.call(heads, function (h) {
      return { n: h.getAttribute('data-name'), f: h.getAttribute('data-for') };
    });
    var procs = Array.prototype.map.call(grid.querySelectorAll('.pv-rowhead[data-proc]'), function (r) {
      return { k: r.getAttribute('data-proc'), n: r.getAttribute('data-label') };
    });

    ticks.innerHTML = '';
    tiers.forEach(function (t, i) {
      var b = el('button', '', esc(t.n));
      b.type = 'button';
      b.addEventListener('click', function () { input.value = i; update(true); });
      ticks.appendChild(b);
    });

    function firstMachine(proc, t) {
      var cell = grid.querySelector('.pv-cell[data-proc="' + proc + '"][data-t="' + t + '"]');
      return cell ? cell.querySelector('.pv-m') : null;
    }

    var shown = 0, raf = null, sel = {};
    function tween(target) {
      if (reduced()) { shown = target; outPr.textContent = money(target); return; }
      var from = shown, t0 = null;
      if (raf) cancelAnimationFrame(raf);
      function step(ts) {
        if (t0 === null) t0 = ts;
        var k = Math.min(1, (ts - t0) / 420), e = 1 - Math.pow(1 - k, 3);
        shown = from + (target - from) * e;
        outPr.textContent = money(shown);
        if (k < 1) raf = requestAnimationFrame(step);
        else { shown = target; outPr.textContent = money(target); }
      }
      raf = requestAnimationFrame(step);
    }

    function update(animate) {
      var i = +input.value, t = tiers[i] || tiers[0], total = 0, count = 0;
      state.tier = i;
      input.style.setProperty('--fill', (i / (tiers.length - 1) * 100) + '%');
      input.setAttribute('aria-valuetext', t.n + ': ' + t.f);
      Array.prototype.forEach.call(ticks.children, function (b, j) {
        b.setAttribute('aria-pressed', j === i ? 'true' : 'false');
      });
      line.innerHTML = '';
      procs.forEach(function (p) {
        var m = firstMachine(p.k, i);
        var on = sel[p.k] !== false;
        var st = el('div', 'pv-st' + (m ? '' : ' pv-off') + (m && !on ? ' pv-skip' : ''));
        st.setAttribute('data-p', p.k);
        st.style.setProperty('--g', GLYPH[i] + 'px');
        var box;
        if (m && m.getAttribute('data-img')) {
          box = '<a class="pv-tile" href="' + esc(m.getAttribute('data-url')) + '" tabindex="-1"><img class="pv-' +
            (m.getAttribute('data-cut') === 'true' ? 'cut' : 'full') + '" src="' + esc(m.getAttribute('data-img')) +
            '" alt="' + esc(m.getAttribute('data-name')) + '" loading="lazy"></a>';
        } else {
          box = '<svg aria-hidden="true"><use href="#pv-g-' + p.k + '"/></svg>';
        }
        var h = '<div class="pv-box">' + box + '</div><div class="pv-sthead"><small>' + esc(p.n) + '</small>' +
          (m ? '<label class="pv-chk"><input type="checkbox" data-p="' + esc(p.k) + '"' + (on ? ' checked' : '') + ' aria-label="Include ' + esc(m.getAttribute('data-name')) + ' in the list price"><span>Include</span></label>' : '') +
          '</div>';
        if (m) {
          var price = +m.getAttribute('data-price') || 0;
          if (on) { total += price; count++; }
          h += '<a class="pv-n" href="' + esc(m.getAttribute('data-url')) + '">' + esc(m.getAttribute('data-name')) + '</a>' +
            '<span class="pv-pr">' + money(price) + '</span>';
          var sp = m.getAttribute('data-spec');
          if (sp) h += '<span class="pv-sp">' + esc(sp) + '</span>';
        } else {
          var cell = grid.querySelector('.pv-cell[data-proc="' + p.k + '"][data-t="' + i + '"]');
          var txt = cell ? cell.textContent.replace(/\s+/g, ' ').trim() : '';
          h += '<span class="pv-nm">' + esc(txt || offText) + '</span>';
        }
        st.innerHTML = h;
        line.appendChild(st);
      });
      outFor.textContent = t.f;
      outSt.textContent = count + ' of ' + procs.length;
      if (animate) tween(total); else { shown = total; outPr.textContent = money(total); }
      Array.prototype.forEach.call(grid.children, function (c) {
        if (c.getAttribute && c.getAttribute('data-t') !== null) {
          c.classList.toggle('pv-sel', +c.getAttribute('data-t') === i);
        }
      });
      syncGoals();
    }
    input.addEventListener('input', function () { update(true); });
    line.addEventListener('change', function (e) {
      var c = e.target;
      if (c && c.type === 'checkbox' && c.getAttribute('data-p')) { sel[c.getAttribute('data-p')] = c.checked; update(true); }
    });
    update(false);

    if (chip) {
      chip.addEventListener('click', function () {
        var on = chip.getAttribute('aria-pressed') !== 'true';
        chip.setAttribute('aria-pressed', on ? 'true' : 'false');
        grid.classList.toggle('pv-filtering', on);
        grid.querySelectorAll('.pv-cell').forEach(function (c) {
          c.classList.toggle('pv-off', on && c.getAttribute('data-v') !== '1');
        });
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-pv-range]:not([data-pv-ready])').forEach(initRange);
    wireGoals();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
